<template>
<div class="chapter">
<div class="inner_page">
<h2><a id="page_14"></a><a id="pg14lev1"></a><img alt="Creamy mushroom soup with bouncy dill fish balls" src="images/f0014-01.jpg"/></h2>
<p class="recipe_hdnote">The archipelago around Stockholm, with its crystal-clear water, crisp fresh air, and untouched scenery, captured what for me is the essence of Sweden. It is the juxtaposition of water and forest that inspired this recipe, and, of course, the Swedes’ love of meatballs. I turned tradition on its head a little, and let the coast inspire these fish balls. But these aren’t just any old fish balls.</p>
<p class="recipe_hdnote">Instead of taking the more traditional Swedish approach to making meatballs (ground meat or fish, rolled into a ball), I’ve taken inspiration from my Chinese heritage. I love the chewy texture of Chinese fish balls, which is created by slapping the flesh around. I’ve spotted old ladies in fish markets in Malaysia doing this. The pounding and slamming of the fish stretches and uncoils the previously wound protein strands, which makes for this unusual bouncy texture.</p>
<div class="wrap">
<p class="image"><a id="page_16"></a><a id="page_17"></a><img alt="image" class="horizontal" src="images/f0016-01.jpg"/></p>
</div>
<p class="yield">Serves 4</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common.jpg"/></p>
</div>
<p class="yield">Preparation time: 25 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common1.jpg"/></p>
</div>
<p class="yield">Cooking time: 30 minutes</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/common2.jpg"/></p>
</div>
<p class="left"><a id="page_15"></a>For the fish balls</p>
<p class="ingred_sublist">14 oz cod or pollack loin, skinned and deboned</p>
<p class="ingred_sublist">2 tbsp chopped fresh dill</p>
<p class="ingred_sublist"><sup>1</sup>/<sub>2</sub> tsp sea salt</p>
<p class="ingred_sublist"><sup>1</sup>/<sub>4</sub> tsp white pepper</p>
<p class="left">For the soup</p>
<p class="ingred_sublist">1 tbsp olive oil</p>
<p class="ingred_sublist">2 knobs of butter</p>
<p class="ingred_sublist">2 onions, peeled and finely chopped</p>
<p class="ingred_sublist">2 cloves of garlic, peeled and minced</p>
<p class="ingred_sublist">2 sprigs of thyme</p>
<p class="ingred_sublist">1 lb portobello mushrooms, roughly chopped</p>
<p class="ingred_sublist">sea salt and freshly ground black pepper</p>
<p class="ingred_sublist">2 cups good-quality beef stock</p>
<p class="ingred_sublist">1<sup>1</sup>/<sub>4</sub> cups heavy cream</p>
<p class="ingred_sublist1">1 knob of butter</p>
<p class="ingred_sublist">2 oz wild mushrooms (such as chanterelles), brushed clean and torn if large</p>
<p class="ingred_sublist">juice and zest of 1 unwaxed lemon</p>
<p class="ingred_sublist">2 to 3 <em>knäckebröd</em> (rye crispbread)</p>
<p class="ingred_sublist">chopped fresh dill for garnish</p>
<p class="method_txt">To make the fish balls: Pat the fish dry with a clean kitchen towel. In a food processor, blend the fish to a smooth paste with the dill, salt, and white pepper. Add about 3 tbsp water and keep blending. Check the consistency and add as much water as needed to bind into a paste; you want it to be pastelike but not too wet to form into balls.</p>
<p class="method_txt">Now it’s time to start slapping your fish. Take the mixture in your hands and keep slapping it down on a clean work surface for a minute or two. As the mixture is thrown down more and more, you will notice a bounce develop in the texture.</p>
<p class="method_txt">Divide the mixture into 16 portions and shape into small balls. If you find it easier, wet your palms before rolling the mixture into neat balls. Place on a clean plate.</p>
<p class="method_txt">To make the soup: Heat the oil and butter in a large saucepan over low heat. Add the onions, garlic, thyme, and mushrooms. Season with salt and black pepper and cook, uncovered, for 15 minutes, or until soft.</p>
<p class="method_txt">Add the stock to the mushrooms, bring to a simmer, and let simmer, uncovered, for 10 minutes. Add the cream. Remove and discard the thyme. Using an immersion blender, blend the soup until smooth.</p>
<p class="method_txt">Fill a medium saucepan with water, bring it to a boil, and drop in the fish balls to cook for 3 minutes, or until they float to the top. Remove with a slotted spoon and set aside.</p>
<p class="method_txt">Heat the butter in a frying pan over medium-high heat. Add the wild mushrooms and sauté for 2 to 3 minutes, then set aside.</p>
<p class="method_txt">Finish the soup by stirring in the lemon juice and tasting for seasoning. Ladle the soup into bowls, adding four fish balls to each. Garnish with some shards of <em>knäckebröd</em> as croutons, fresh dill, and the lemon zest. Scatter some of the sautéed mushrooms over the soup in each bowl before serving.</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/f0013-01.jpg"/></p>
</div>
<div class="sidebar">
<p class="sidebar1_hd">Tip</p>
<p class="sidebar1_txt"><em>Soak the bowl of your blender or food processor immediately after making the fish paste, as it has a tendency to stick!</em></p>
<p class="sidebar2_hd">Get ahead</p>
<p class="sidebar1_txt"><em>You can make the soup a day before. The fish balls can be formed the day before serving. Store in an airtight container and cook just before serving.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08-chapter02.vue?31a0c29e